module.exports = __webpack_public_path__ + "img/ic_many_point_wh.ebe37bd9.svg";